export const selectSportHistoryLocale = (state) => state.locale.locale.sportHistory;
